import { CloseIcon } from "@chakra-ui/icons";
import {
    Box,
    IconButton as ChakraIconButton,
    Flex,
    HStack,
    Icon,
    Image,
    Stack,
    Text,
    useBreakpointValue,
    useDisclosure,
    useMediaQuery,
} from "@chakra-ui/react";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { MdAccessTime } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addDeliveryPickupDetails } from "../../actions/delivery_pickup_action";
import Colors from "../../assets/colors/Colors";
import payError from "../../assets/images/payError.svg";
import * as Constants from "../../constants/Constants";
import HomeText from "../../modules/home/components/HomeText";
import styles from "../../modules/home/styles/home.module.css";
import { GrubDropDown, GrubFormButton, GrubProgress } from "../index";
import GrubTitleText from "../title/GrubTitleText";

const ErrorMessage = (props) => {
    return (
        <HStack
            minH="3.13rem"
            w={props.width}
            bg="#FFECE2"
            pt="0.5rem"
            pb="0.5rem"
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
            borderRadius="0.44rem"
            mt="0.5rem"
        >
            <Stack
                w={"10%"}
                gap="0.5rem"
                alignItems="center"
                justifyContent="center"
                alignSelf="center"
            >
                <Image src={payError} alt="warning" boxSize="1.5rem" />
            </Stack>
            <Stack w={"90%"}>
                <Text
                    color={Colors.posCancleButtonMuiRed}
                    fontSize={"0.87rem"}
                    lineHeight={"0.95rem"}
                    fontWeight={300}
                >
                    {props.errorMessage}
                </Text>
            </Stack>
        </HStack>
    );
};

const GrubTimeSlotDialog = (props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const isMobile = useBreakpointValue({ base: true, md: false });
    const [isLarge] = useMediaQuery("(min-width: 660px)");
    const [isMedium] = useMediaQuery("(min-width: 480px)");

    // constants
    const selectedScheduleOptions = Constants.SCHEDULE_TYPES;

    // states
    const [errorMessage, setErrorMessage] = useState("");
    const [timeSlot, setTimeSlot] = useState([]);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
    const [selectedScheduleType, setSelectedScheduleType] = useState("asap");
    const [stateData, setStateData] = useState({
        scheduled_type: "asap",
        deliveryTime: "",
        asapTimeSlot: "",
        saveDeliveryAddress: false,
    });
    const [asapTime, setAsapTime] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (props.isOpen) {
            onOpen();
            handleTimeSlot();
        }
    }, [props.isOpen]);

    const handleSelectedScheduleType = (value) => {
        setSelectedScheduleType(value);
        setStateData((prevState) => ({ ...prevState, scheduled_type: value }));
        setSelectedTimeSlot("");
        if (value == "asap") {
            setStateData((prevState) => ({ ...prevState, deliveryTime: "" }));
            const asapSlot = timeSlot.find(
                (slot) => slot.id == stateData.asapTimeSlot
            );
            setAsapTime(asapSlot.time.split(" - ")[0].trim());
        }
    };

    const handleSelectedTimeSlot = (value) => {
        setSelectedTimeSlot(value);
        setStateData((prevState) => ({ ...prevState, deliveryTime: value }));
        setErrorMessage("");
    };

    const handleTimeSlot = () => {
        const locations = [props.delivery_pickup[0]?.location];
        if (locations.length > 0) {
            locations.forEach((location) => {
                location.location_online_order_settings.forEach(
                    (online_settings) => {
                        try {
                            const [hours, minutes, seconds] =
                                props.delivery_pickup[0]?.order_type == "pickup"
                                    ? online_settings?.pickup_lead_time?.split(
                                          ":"
                                      )
                                    : online_settings?.delivery_lead_time?.split(
                                          ":"
                                      );
                            const addTimeToday = moment()
                                .add(seconds, "seconds")
                                .add(minutes, "minutes")
                                .add(hours, "hours")
                                .format("ddd");
                            const finalTime = moment()
                                .add(seconds, "seconds")
                                .add(minutes, "minutes")
                                .add(hours, "hours")
                                .format("hh:mm A");
                            if (
                                online_settings.location_hrs_sub_slot.length > 0
                            ) {
                                const currentTime = moment().format("hh:mm A");
                                const storeOpenTime =
                                    online_settings.location_hrs_sub_slot[0]
                                        .from_time;
                                const storeCloseTime =
                                    online_settings.location_hrs_sub_slot[
                                        online_settings.location_hrs_sub_slot
                                            .length - 1
                                    ].to_time;
                                if (
                                    moment(currentTime, ["h:mm A"]).isBefore(
                                        moment(storeOpenTime, ["h:mm A"])
                                    )
                                ) {
                                    setTimeSlot([]);
                                    setErrorMessage(
                                        Constants.STORE_OPEN_BEFORE_ORDER_START
                                    );
                                } else if (
                                    moment(currentTime, ["h:mm A"]).isAfter(
                                        moment(storeCloseTime, ["h:mm A"])
                                    )
                                ) {
                                    setTimeSlot([]);
                                    setErrorMessage(
                                        Constants.STORE_CLOSE_AFTER_ORDER_START
                                    );
                                } else {
                                    let storeTimeSlot = [];
                                    let i = 1;
                                    if (
                                        online_settings.location_hrs_sub_slot[0]
                                            .day === addTimeToday.toUpperCase()
                                    ) {
                                        online_settings.location_hrs_sub_slot.forEach(
                                            (timeSlot) => {
                                                if (
                                                    moment(timeSlot.from_time, [
                                                        "h:mm A",
                                                    ]).isAfter(
                                                        moment(finalTime, [
                                                            "h:mm A",
                                                        ])
                                                    )
                                                ) {
                                                    if (i === 1) {
                                                        setStateData(
                                                            (prevState) => ({
                                                                ...prevState,
                                                                asapTimeSlot:
                                                                    timeSlot.id,
                                                            })
                                                        );
                                                        i = 0;
                                                    }
                                                    if (
                                                        props.delivery_pickup[0]
                                                            ?.scheduleOrder ==
                                                            "custom" &&
                                                        props.delivery_pickup[0]
                                                            ?.DeliveryTime
                                                            ?.id == timeSlot.id
                                                    ) {
                                                        setSelectedScheduleType(
                                                            "custom"
                                                        );
                                                        setSelectedTimeSlot({
                                                            id: timeSlot.id,
                                                            time: `${timeSlot.from_time} - ${timeSlot.to_time}`,
                                                        });
                                                    } else if (
                                                        props.delivery_pickup[0]
                                                            ?.scheduleOrder ==
                                                        "custom"
                                                    ) {
                                                        setSelectedScheduleType(
                                                            "custom"
                                                        );
                                                    }
                                                    storeTimeSlot.push({
                                                        id: timeSlot.id,
                                                        time: `${timeSlot.from_time} - ${timeSlot.to_time}`,
                                                    });
                                                }
                                            }
                                        );
                                        if (storeTimeSlot.length > 0) {
                                            setAsapTime(
                                                storeTimeSlot[0].time
                                                    .split(" - ")[0]
                                                    .trim()
                                            );
                                            setTimeSlot(storeTimeSlot);
                                        } else {
                                            setTimeSlot([]);
                                            setErrorMessage(
                                                Constants.PICKUP_TIME_SLOTE_NOT_FOUND
                                            );
                                        }
                                    } else {
                                        setTimeSlot([]);
                                        setErrorMessage(
                                            Constants.DAY_CHANGE_TIME_SLOTE_NOT_AVAILABLE
                                        );
                                    }
                                }
                            }
                        } catch (error) {
                            setTimeSlot([]);
                            setErrorMessage(
                                Constants.PICKUP_TIME_SLOTE_NOT_FOUND
                            );
                        }
                    }
                );
            });
        }
    };

    const handleModalClose = () => {
        setErrorMessage("");
        setSelectedTimeSlot("");
        setSelectedScheduleType("asap");
        setAsapTime("");
        setStateData({
            scheduled_type: "asap",
            deliveryTime: "",
            asapTimeSlot: "",
            saveDeliveryAddress: false,
        });
        props.onClose();
        onClose();
    };

    const handleSubmit = () => {
        if (selectedScheduleType == "custom") {
            if (selectedTimeSlot == "") {
                setErrorMessage(
                    props.delivery_pickup[0]?.order_type === "delivery"
                        ? Constants.DELIVERY_TIME_SELECT_ERROR
                        : Constants.PICKUP_TIME_SELECT_ERROR
                );
                return;
            }
        }
        const orderDetails = {
            order_type: props.delivery_pickup[0]?.order_type,
            location: props.delivery_pickup[0]?.location,
            address: props.delivery_pickup[0]?.address,
            city: props.delivery_pickup[0]?.city,
            state: props.delivery_pickup[0]?.state,
            zipCode: props.delivery_pickup[0]?.zipCode,
            country: props.delivery_pickup[0]?.country,
            scheduleOrder: selectedScheduleType,
            DeliveryTime: selectedTimeSlot,
            place_id: props.delivery_pickup[0]?.place_id,
        };
        props.addDeliveryPickupDetails(orderDetails);
        setIsLoading(false);
        props.handleCheckout();
        onClose();
    };

    return (
        <Dialog
            visible={isOpen}
            style={{
                width: isLarge ? "38.31rem" : isMedium ? "28.31rem" : "92%",
                height: isMobile ? "auto" : "35rem",
            }}
            onHide={handleModalClose}
            showHeader={false}
            modal={true}
            blockScroll={true}
            className="dialog-overlay"
        >
            {isLoading && <GrubProgress />}
            <Flex justifyContent={"flex-end"} mt={4}>
                <ChakraIconButton
                    bg={Colors.posTextAreaBackground}
                    mb="0.88rem"
                    borderRadius="1.5rem"
                    onClick={handleModalClose}
                    height="1.88rem"
                    minW="1.88rem"
                    variant="posghost"
                    icon={
                        <CloseIcon
                            color={Colors.posTextInfo}
                            boxSize="0.75rem"
                            fontWeight="300"
                        />
                    }
                />
            </Flex>
            <GrubTitleText
                isLabelText={true}
                color={Colors.posTextInfo}
                name={"Order Type"}
            />
            <GrubTitleText
                isLabelText={true}
                color={Colors.posTextInfo}
                fontSize={"0.87rem"}
                lineHeight={"0.95rem"}
                fontWeight={300}
                name={"Please select preferred order type"}
            />
            <Stack
                mt={{ base: "1.5rem", md: "1.5rem" }}
                spacing={2}
                height={{ base: "20rem", md: "20rem" }}
                minHeight={{ base: "20rem", md: "10rem" }}
                borderRadius="0.44rem"
                border="0.5px solid #C3D1E6B2"
                overflowY="auto"
                justifyContent="flex-start"
            >
                <Box
                    w="90%"
                    justifyContent="center"
                    alignItems="center"
                    alignSelf="center"
                    css={{
                        "&::-webkit-scrollbar": {
                            width: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                            width: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "gray.200",
                            borderRadius: "24px",
                        },
                    }}
                >
                    <HomeText
                        isLabelText={true}
                        color={Colors.primeposTextInfo}
                        name={"Please Select*"}
                        fontWeight={400}
                        mt={4}
                    />
                    <GrubDropDown
                        width="100%"
                        lableAvailable={true}
                        id="selectedSchedule"
                        value={selectedScheduleType}
                        filter={false}
                        dropdownClassName={styles["p-dropdown-panel"]}
                        onChange={(e) => {
                            if (
                                undefined != e.value &&
                                null != e.value &&
                                "" != e.value
                            ) {
                                handleSelectedScheduleType(e.target.value);
                            }
                        }}
                        options={selectedScheduleOptions}
                        optionLabel={"name"}
                        className="w-full md:w-20rem"
                        placeholder={"Select Scheduling Type"}
                    />
                    {selectedScheduleType == "custom" ? (
                        <>
                            <Box mt={4}>
                                <HomeText
                                    isLabelText={true}
                                    color={Colors.primeposTextInfo}
                                    name={"Select Time*"}
                                    fontWeight={400}
                                    mt={4}
                                />
                            </Box>
                            <GrubDropDown
                                width="100%"
                                lableAvailable={true}
                                id="selectedSchedule"
                                value={selectedTimeSlot}
                                dropdownClassName={styles["p-dropdown-panel"]}
                                onChange={(e) => {
                                    if (
                                        undefined != e.value &&
                                        null != e.value &&
                                        "" != e.value
                                    ) {
                                        handleSelectedTimeSlot(e.target.value);
                                    }
                                }}
                                filter={false}
                                options={timeSlot}
                                optionLabel={"time"}
                                className="w-full md:w-20rem"
                                placeholder={"Select Time"}
                            />
                            {errorMessage && errorMessage.length > 0 && (
                                <ErrorMessage
                                    errorMessage={errorMessage}
                                    width="100%"
                                />
                            )}
                        </>
                    ) : (
                        typeof stateData === "object" && (
                            <Box
                                bg="#BBFBC52E"
                                border="1px solid"
                                borderColor="#09B825"
                                borderRadius="7px"
                                p={4}
                                mt={4}
                                // maxW="400px"
                                w="100%"
                            >
                                <Flex mb={2} align="center">
                                    <Icon
                                        as={MdAccessTime}
                                        color="green.500"
                                        boxSize={5}
                                        mr={2}
                                    />
                                    <HomeText
                                        isLabelText={true}
                                        name={
                                            props.delivery_pickup[0]
                                                ?.order_type == "delivery"
                                                ? "Order Delivery Time:"
                                                : "Order Pickup Time:"
                                        }
                                        color={"#04A01D"}
                                        fontWeight={500}
                                    />
                                </Flex>
                                <HomeText
                                    isLabelText={true}
                                    name={
                                        "Next order will be available Today: " +
                                        (!asapTime ? "N.A." : asapTime)
                                    }
                                    color={"#121010B2"}
                                    fontWeight={300}
                                />
                            </Box>
                        )
                    )}
                </Box>
            </Stack>
            <Stack
                mt={"2rem"}
                spacing={2}
                justifyContent="center"
                alignItems="center"
                w="100%"
            >
                <GrubFormButton
                    bg={Colors.posTextInfo}
                    buttonsubmit={"Submit"}
                    width={"90%"}
                    onClick={handleSubmit}
                    autoFocus={false}
                />
            </Stack>
        </Dialog>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addDeliveryPickupDetails,
        },
        dispatch
    );
}
function mapStateToProps(state) {
    return {
        delivery_pickup: state.delivery_pickup,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GrubTimeSlotDialog);
